import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ClientState } from '../reducers';

export const selectClientState = createFeatureSelector<ClientState>('client');

export const selectClientLoading = createSelector(selectClientState, (state: ClientState) => state.loading);

export const selectClient = createSelector(selectClientState, (state: ClientState) => state.client);

export const selectClientLocation = createSelector(selectClientState, (state: ClientState) => state.location);

export const selectApartmentOrSuite = createSelector(selectClientState, (state: ClientState) => state.apartmentOrSuite);

export const selectDeliveryInstructions = createSelector(selectClientState, (state: ClientState) => state.deliveryInstructions);

export const selectUser = createSelector(selectClientState, (state: ClientState) => state.user);

export const selectClientError = createSelector(selectClientState, (state: ClientState) => state.error);

export const selectClientAddressForm = createSelector(selectClientState, (state: ClientState) => state.clientAddressForm);

export const selectClientAddressId = createSelector(selectClientState, (state: ClientState) => state.idAddress);

export const selectClientForm = createSelector(selectClientState, (state: ClientState) => state.personalInformationForm);
